<template>
  <template v-for="deal in deals" :key="deal.title">
    <menu-item-image
      v-if="deal.image"
      :image="deal.image.src"
      :alt-text="deal.image.alt || ''"
      class="iorder-menu-item-deal"
    >
      <button class="btn btn--primary" type="button" @click="onDealClick(deal.title)">
        {{ t('iorder-view-deal') }}
      </button>
    </menu-item-image>
    <deal-modal v-if="activeModal === deal.title" :card="deal" @close-modal="onCloseModal" />
  </template>
</template>

<script setup lang="ts">
import type { MenuItemDealProps } from './types';
import type { DealCard } from '../types';
import { ref, computed } from 'vue';
import MenuItemImage from '../MenuItemImage/MenuItemImage.vue';
import DealModal from '../DealCarousel/DealModal/DealModal.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const props = withDefaults(defineProps<MenuItemDealProps>(), {
  deals: () => ({ value: [] }),
  menuName: '',
  categoryName: '',
});

const activeModal = ref<string | null>(null);

const equalsIgnoreCase = (str1: string, str2: string) =>
  str1?.toLowerCase() === str2?.toLowerCase();

const matchesCategoryName = (deal: DealCard) =>
  equalsIgnoreCase(deal.sectionKey ?? '', props.categoryName);

const matchesMenuName = (deal: DealCard) => equalsIgnoreCase(deal.menuKey ?? '', props.menuName);

const deals = computed(
  () =>
    props.deals?.value?.filter(
      (deal: DealCard) => matchesMenuName(deal) && matchesCategoryName(deal)
    ) || []
);

const onDealClick = (title: string) => {
  activeModal.value = title;
};

const onCloseModal = () => {
  activeModal.value = null;
};
</script>

<style lang="scss">
@import './scss/MenuItemDeal.scss';
</style>
